import React, { Component } from 'react'
import PlusIcon from '../../icons/plusicon';
import FpgPlusIcon from '../../icons/fpgplusicon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DraggerIcon from '../../icons/draggericon';
import CatEditIcon from '../../icons/catediticon';
import FpgMinusIcon from '../../icons/fpgminusicon';
import TextField from '../../component/TextField'
import service from "../../services";
import SimpleReactValidator from 'simple-react-validator';
import Loader from '../../component/loader';
//moment import
import moment from "moment";
//sweet alert
import swal from "sweetalert";
import { connect } from 'react-redux';
let sub;

class Amenities extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            loaderFlag:false,
            addVenuemodal:false,
            editVenuemodal:false,
            editAmenities:false,
            amenitielist:[],
            amenitiesName:"",
            updateAmenitiesId:"",
            description:"",
            lastUpdatedBy:"",
            lastUpdatedAt:"",
            isEdited: false
        }
        this.apiserve = new service();
        this.validator = new SimpleReactValidator({ autoForceUpdate: this,
            validators: {
                amenitiesName: {  // name the rule
                  message: 'Amenity Name is required.',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,/^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                  },
                  required: true  // optional
                },
                description: {  // name the rule
                  message: 'Amenity Description is required.',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,/^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                  },
                  required: true  // optional
                },
              }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
      };

    componentDidMount() {
        this.updatedAt()
        if (this.props.allInitial && this.props.allInitial.location && this.props.allInitial.location.amenity) {
            this.setState({
                amenitielist: this.props.allInitial.location.amenity
            })
        }
        let self = this;

        sub = this.apiserve.getevent().subscribe((response) => {
            this.setState({
                loaderFlag:false
            })
            switch (response.event) {

            case "location|amenity|add" :
               if(!response.error)
               {
                   self.CloseModal();
               }
               break;
            case "location|amenity|update" :
                if(!response.error)
                {
                    self.CloseModal();
                }
                break;
            case "location|amenity|remove":
                if(!response.error)
                {
                    self.CloseModal();
                }
                break;
            case "location|amenity|changeOrder":
                if(!response.error){
                }
                break;
                case "location|getLastUpdated":
                    if(!response.error){
                        
                        this.setState({
                            lastUpdatedBy:response?.data?.updatedBy,
                            lastUpdatedAt:response?.data?.updatedAt,
                        })
                    }    
                break;  
            }

          });


    }

    componentDidUpdate(prevProps) {
        if (prevProps.allInitial !== this.props.allInitial) {
            if (this.props.allInitial && this.props.allInitial.location && this.props.allInitial.location.amenity) {
                this.setState({
                    amenitielist: this.props.allInitial.location.amenity
                })
            }
        }
    }
    updatedAt = () => { 
        let data={
            type:"5"
        }
        this.apiserve.sendevent("location|getLastUpdated", data);
    }

    AddVenue = () => {
        this.validator.hideMessages("");
        this.setState({
            addVenuemodal:true,
            amenitiesName:"",
            description:"",
            isEdited: true
        })
    }

    CloseModal = () => {
        this.setState({
            addVenuemodal:false,
            editAmenities:false,
            amenitiesName:"",
            description:"",
            updateAmenitiesId:"",
            isEdited: false
        })
        this.validator.hideMessages("");
    }


    editAmenities = (data) => {
        this.setState({
            addVenuemodal:true,
            editVenuemodal:true,
            amenitiesName:data.name,
            updateAmenitiesId:data._id,
            description: data.description,
            editAmenities:true,
            isEdited: false
        })
    }

    onDragEnd = (result) => { 
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.amenitielist];
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                amenityId: _id,
                sortIndex: i + 1,
            });
        });

        const data = { order: updateArr };
        this.apiserve.sendevent("location|amenity|changeOrder", data);

        
        this.setState({ isDraggable: true });
        this.setState({ amenitielist: arr });
    }

    deleteAccess = (data) => {
        // this.setState({
        //     loaderFlag:true
        // })
       

        swal({
            title: "Are you sure you want to delete this record?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
            swal("Your record has been deleted!", {
                icon: "success",
            });
            this.apiserve.sendevent("location|amenity|remove", { amenityId : data._id });
            } else {
            swal("Your record is safe!");
            }
        });
    }

    addAmenities = () => {
        this.setState({
            addVenuemodal:true,
            isEdited: true
        })
    }

    onInputChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        this.updateState({
            [name]: value
        })
    }

    updateState = (data, callback) => {
        this.setState({
            ...data,
            isEdited: true
        }, callback);
    }

    submitFn = (e) => {
        e.preventDefault();
        if (this.validator.allValid()){
            this.setState({ loaderFlag: true})
            const { amenitiesName, description, updateAmenitiesId } = this.state;
            let data;

            if(updateAmenitiesId)
            {
                data = {
                    name: amenitiesName,
                    description: description,
                    amenityId: updateAmenitiesId
                }
                this.CloseModal();
            }
            else
            {
                data = {
                    name: amenitiesName,
                    description: description
                }
                this.CloseModal();
                
            }
            this.apiserve.sendevent(updateAmenitiesId ? "location|amenity|update" : "location|amenity|add", data);
        }
        else{
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    
    render() {
        var updateAt = new Date (this.state.lastUpdatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')

        return (
            <div className="right_side_wrapper ">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>LOCATION</div>
                            <span onClick={this.addAmenities}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <p></p>
                    <p className="update_date">
                            Last Update: {hour}:{minutes} {state} -  {moment(this.state.lastUpdatedAt).format('MM/DD/YY') } 
                        </p>
                </div>
                <div className="cat_outer_content">
                    <div className="category_add_edit">
                    <div className="category_header relative">
                        <p>Amenities </p>
                        <span className="add_icon d_flex" onClick={this.AddVenue}>
                        <FpgPlusIcon
                            width="16"
                            height="16"
                            color="#ffffff"
                            stroke="#4F4F4F"
                        />
                        </span>
                    </div>
                    <div className="list_wrap striped_droppable_table">
                        <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                            <ul {...provided.droppableProps} ref={provided.innerRef}>
                                {this.state.amenitielist?.map((item, index) => (
                                <Draggable
                                    key={item._id}
                                    draggableId={item._id}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                    <li
                                        className="pointer d_flex d_flex_align_center"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        <span className="cat_drag d_flex">
                                            <DraggerIcon />
                                        </span>
                                        <p className="cat_name">{item.name}</p>
                                        <div className="action d_flex d_flex_align_center">
                                        <span
                                            className="cat_edit pointer"
                                            onClick={() => this.editAmenities(item)}
                                        >
                                            <CatEditIcon />
                                        </span>
                                        <span
                                            className="remove_cat pointer"
                                            onClick={() => this.deleteAccess(item)}
                                        >
                                            <FpgMinusIcon
                                            width="16"
                                            height="16"
                                            color="#4F4F4F"
                                            />
                                        </span>
                                        </div>
                                    </li>
                                    )}
                                </Draggable>
                                ))}
                            </ul>
                            )}
                        </Droppable>
                        </DragDropContext>
                    </div>
                    </div>
                </div>
            
            
            {/* Loader */}
            {this.state.loaderFlag ? (
                <Loader />
            ) : (
                    ""
            )}
            {/* popup */}
            <div className={`user_popup ${this.state.addVenuemodal ? "active" : ""}`} >
                <span className="popup_overlay" onClick={this.CloseModal}></span>
                <div className="cat_modal_inner">
                <p className="cat_title text_center">
                {this.state.editAmenities ? 'Edit Amenity' : 'Amenity'}
                </p>
                <form onSubmit={(e) => this.submitFn(e)}>
                    <div className="field_row horizontal_field d_flex">
                    <TextField
                        type="text"
                        label="Amenity Name"
                        name="amenitiesName"
                        id="amenitiesName"
                        value={this.state.amenitiesName}
                        onChange={this.onInputChange}
                        fpgerror={this.validator.message( "Venue Type Name", this.state.amenitiesName, "amenitiesName|required"  )}
                    />
                   
                    </div>
                    <div className="field_row horizontal_field d_flex">
                    <label>Amenity Description</label>
                    <div className="textarea_wrap">
                        <textarea
                        type="text"
                        rows="12"
                        name="description"
                        value={this.state.description}
                        onChange={this.onInputChange}
                        ></textarea>
                        <span style={{ color: "red" }}>
                            {this.validator.message( "Description", this.state.description, "description|required" )}
                        </span> 
                    </div>
                    </div>
                    <div className="cat_btns text_center">
                    <button type="button" onClick={this.CloseModal}>
                        CANCEL
                    </button>
                    <button
                        className={this.state.editAmenities && !this.state.isEdited ? "disabled" : "active"}
                        disabled={this.state.editAmenities && !this.state.isEdited}
                        onClick={(e) => this.submitFn(e)}
                    >
                       {this.state.updateAmenitiesId ? "UPDATE":"SAVE"} 
                    </button>
                    </div>
                </form>
                </div>
            </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        allInitial: state.allInitial,
    };
};

export default connect(mapStateToProps)(Amenities);
